<template>
  <select-input
    :name="name"
    :placeholder="placeholder"
    :options="opts"
    :label="label"
    :modelValue="modelValue"
    :includeBlank="includeBlank"
    @update:modelValue="emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
import { USStates } from "@/components/layout/forms/us_states"

export default {
  props: {
    modelValue: {
      type: String,
    },
    placeholder: {
      type: Boolean,
    },
    abbreviation: {
      type: Boolean,
      default: true,
    },
    includeBlank: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
      default: "State"
    },
  },
  setup(props, { emit }) {
    const opts = USStates.map((state) => {
      return {
        name: props.abbreviation ? state.abbreviation : state.name,
        key: state.abbreviation
      }
    })
    return {
      opts,
      emit,
    }
  },
}
</script>

<style scoped>
</style>
